<template>
  <div class="headerComp needResize" id="header">
    <div class="header-item">
      <div class="circle background-client">
        <div class="icon-client"></div>
      </div>
      <div class="header-number">{{customerNumbers | splitNumber}}</div>
      <div class="header-text">{{$t('header.clients')}}</div>
    </div>
    <div class="header-item">
      <div class="circle background-ticket">
        <div class="icon-ticket"></div>
      </div>
      <div class="header-number">{{nbBills | splitNumber}}</div>
      <div class="header-text">{{$t('header.tickets')}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Header',
    props: {
      result: Object,
      reference: Object
    },
    data() {
      return {
        
      }
    },
    mounted() {
    },
    computed: {
      customerNumbers: function(){
        return (this.result && this.result.hits) ? this.result.hits.total : 0
      },
      customerDiff: function() {
        return (this.reference && this.reference.result && this.result && this.result.hits) ? this.reference.result.hits.total - this.customerNumbers : 0
      },
      nbBills: function(){
        return (this.result && this.result.aggregations && this.result.aggregations["to-bills"] && this.result.aggregations["to-bills"].bills) ? this.result.aggregations["to-bills"].bills.doc_count : 0
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/header.sass"
</style>